import React from "react";
import * as styles from "./FormSelect.module.css";

interface Props {
  name?: string;
  id?: string;
  className?: string;
  register?: any;
}

export const FormSelect: React.FC<Props> = ({
  name,
  id,
  className,
  children,
  register,
  ...props
}) => {
  let fullClassName = styles.selectWrap;
  if (className) {
    fullClassName += ` ${className}`;
  }

  return (
    <div className={fullClassName}>
      <select name={name} id={id} {...register}>
        {children}
      </select>
    </div>
  );
};
